import React,{useEffect} from 'react'
import Style from './Details.module.css'
import { NavLink } from 'react-router-dom';

function Details({city}) {
    const {name , min, max , temp , press , country, img} = city
    const {contenedor,close, bClose,content, subContent , titles, title , subTitle, props_subContent, propTitle, container_button} = Style

    return (
    <div className={contenedor} >
        <div className={container_button}>
            <div className={close}>
                <NavLink to='/' className={bClose}>
                    <span>BACK</span>
                </NavLink>
            </div>
        </div>
        <div className={content}>
            <div className={subContent}>
                <div className={titles}>
                    <h1 className={title}>{name}</h1>
                    <h3 className={subTitle}>{country}</h3>
                </div>
                <div className="props_Content">
                    <img src={`http://openweathermap.org/img/wn/${img}@2x.png`} alt='img temp' />
                    <div className="temp">
                        <h3 className={propTitle}>temp</h3>
                        <p>{temp}</p>
                    </div>
                    <div className={props_subContent}>
                       <div className="min">
                            <h3 className={propTitle}>temp Min</h3>
                            <p>{min}</p>
                       </div>

                        <div className="max">
                            <h3 className={propTitle}>temp Max</h3>
                            <p>{max}</p>
                        </div>
                    </div>
                    <div className="press">
                        <h3 className={propTitle}>presion</h3>
                        <p>{press}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default Details